@if (categorySlug) {
    <a [routerLink]="['/products', 'category', categorySlug, product.slug] | localize">
        <ng-template [ngTemplateOutlet]="productThumbnail"></ng-template>
    </a>
}

@if (!categorySlug) {
    <a [routerLink]="['/products', 'all', product.slug] | localize">
        <ng-template [ngTemplateOutlet]="productThumbnail"></ng-template>
    </a>
}

<ng-template #productThumbnail>
    <div
        class="border item"
        [ngClass]="{
            'item-m': !isBig,
            'item-l': isBig,
        }"
    >
        <div class="px-xl-6 pb-xl-6 px-md-5 pb-md-5 px-4 pb-4">
            <div class="d-flex flex-column h-100">
                <div class="img flex-grow-1">
                    @if (product.image?.url; as url) {
                        <img [src]="url" alt="" />
                    }
                    @if (!product.image?.url) {
                        <img appProductCatalogue [stelmachID]="product.patternName" alt="" />
                    }
                </div>
                <div class="mt-auto lh-1">
                    <h6 class="text-secondary fs-15 fw-700 font-secondary mb-1 text-oneline">{{ product.name }}</h6>
                    <span class="text-gray-300 fs-12 lh-1">{{ product.parameters.width + 'mm' }}</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>
